import { QueryResult, QueryConfig } from "@/shared/types/base";
import { sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";
import { Organizacion } from "@/shared/types/organizacion";

export async function getOrganizacion(id: string): Promise<Organizacion> {
    await sleep(1000);
    const response = await api.get("organizaciones/" + id);
    return response.data;
}

export function useGetOrganizacionQuery(id: string, queryConfig: QueryConfig<Organizacion> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getOrganizacion(id),
        queryKey: ["organizaciones", id],
    })
}

export interface GetOrganizacionQueryProps {
    id: string,
    queryConfig?: QueryConfig<Organizacion>,
    children?: (queryResult: QueryResult<Organizacion>) => ReactNode
}

export function GetOrganizacionQuery({
    id,
    children,
    queryConfig
}: GetOrganizacionQueryProps) {
    const queryResult = useGetOrganizacionQuery(id, queryConfig);
    return children && children(queryResult);
}